import Swiper from 'swiper'
import SwiperCore, { Navigation, Lazy } from 'swiper/core'

SwiperCore.use([Navigation, Lazy])

export default class FeaturedArticles {
  constructor(component) {
    this.refs = {
      container: '.js-featuredArticlesContainer',
      textContainer: '.js-textContainer',
      prev: '.js-featuredArticlePrev',
      next: '.js-featuredArticleNext',
      navButtons: '.js-navButtons',
      textWrapper: '.js-textWrapper',
      slideIndex: '.js-slideIndex',
      link: '.js-link',
    }
    this.dom = {
      $component: component,
      $container: component.querySelector(this.refs.container),
      $textContainers: component.querySelectorAll(this.refs.textContainer),
      $prev: component.querySelector(this.refs.prev),
      $next: component.querySelector(this.refs.next),
      $navButtons: component.querySelector(this.refs.navButtons),
      $slideIndex: component.querySelector(this.refs.slideIndex),
    }
    this.state = {
      swiper: null,
    }

    this.mount()
    this.bindToWindow()
  }

  mount() {
    this.initSlider()
    this.linkClickHandler()
  }

  linkClickHandler() {
    const { dom } = this
    dom.$textContainers.forEach((container) => {
      container.addEventListener('click', this.urlRedirect.bind(this))
    })
  }

  urlRedirect(element) {
    const link = element.target.querySelector(this.refs.link).href
    window.location.href = link
  }

  initSlider() {
    const { dom, state, refs } = this

    if (dom.$container) {
      state.swiper = new Swiper(refs.container, {
        slidesPerView: 'auto',
        loop: true,
        preloadImages: false,
        lazy: true,
        navigation: {
          prevEl: dom.$prev,
          nextEl: dom.$next,
        },
      })

      state.swiper.init()

      state.swiper.on('slideChange', () => {
        this.updateNav()
      })
    }
  }

  updateNav() {
    const { dom, state, refs } = this

    const { realIndex, activeIndex } = state.swiper
    const activeSlide = state.swiper.slides[activeIndex]
    const activeSlideTextEl = activeSlide.querySelector(refs.textWrapper)

    dom.$slideIndex.innerHTML = realIndex + 1
    activeSlideTextEl.insertBefore(dom.$navButtons, activeSlideTextEl.firstChild)
  }

  bindToWindow() {
    window.theme = window.theme || {}
    window.theme.FeaturedArticles = this
  }
}
